'use client'

import { useEffect, useState } from 'react'

export function useNoSsr<T>(callback: () => T): T | undefined

export function useNoSsr<T1, T2>(callback: () => T1, fallback: () => T2): T1 | T2

export function useNoSsr<T1, T2>(callback: () => T1, fallback?: () => T2): T1 | T2 | undefined {
  const [mounted, setMounted] = useState(false)
  useEffect(() => setMounted(true), [])
  if (!mounted) {
    return fallback?.()
  }
  return callback()
}
